var map = {
	"./0_small.png": 6868,
	"./156_amarelo_small.png": 5581,
	"./1_small.png": 2187,
	"./2_small.png": 9389,
	"./3_small.png": 2198,
	"./4_small.png": 5147,
	"./5_small.png": 6177,
	"./agulha_small.png": 2971,
	"./comercio_academia_small.png": 791,
	"./comercio_advogados_small.png": 2844,
	"./comercio_agencia_small.png": 1845,
	"./comercio_alimentacao_small.png": 4244,
	"./comercio_animais_small.png": 9048,
	"./comercio_antiguidades_small.png": 9977,
	"./comercio_associacoes_small.png": 3566,
	"./comercio_atacado_small.png": 2884,
	"./comercio_automoveis_small.png": 9216,
	"./comercio_autopecas_small.png": 9546,
	"./comercio_banco_small.png": 9246,
	"./comercio_bar_small.png": 5821,
	"./comercio_beleza_small.png": 2291,
	"./comercio_buffets_small.png": 1155,
	"./comercio_calhas_small.png": 5521,
	"./comercio_comunicacao_small.png": 2498,
	"./comercio_construcoes_small.png": 9803,
	"./comercio_contabil_small.png": 1170,
	"./comercio_conveniencia_small.png": 4771,
	"./comercio_cooperativas_small.png": 261,
	"./comercio_cursos_small.png": 6205,
	"./comercio_dentista_small.png": 9350,
	"./comercio_distribuidora_small.png": 981,
	"./comercio_ervateira_small.png": 7417,
	"./comercio_escola_small.png": 6362,
	"./comercio_esporte_small.png": 43,
	"./comercio_esquadrias_small.png": 2589,
	"./comercio_estetica_small.png": 2010,
	"./comercio_farmacia_small.png": 8512,
	"./comercio_festa_small.png": 5523,
	"./comercio_papelaria_small.png": 3094,
	"./comercio_salao_small.png": 792,
	"./educacao_biblioteca_small.png": 2966,
	"./educacao_creche_small.png": 5931,
	"./educacao_fundamental_small.png": 7135,
	"./educacao_infantil_small.png": 1316,
	"./educacao_jovens_e_adultos_small.png": 4855,
	"./educacao_medio_small.png": 9996,
	"./educacao_superior_small.png": 1569,
	"./ginasio_small.png": 5814,
	"./lazer_academia_small.png": 7666,
	"./lazer_feira_small.png": 7323,
	"./lazer_ginasio_small.png": 1097,
	"./lazer_historico_small.png": 1356,
	"./lazer_museu_small.png": 3130,
	"./lazer_parque_small.png": 1601,
	"./lazer_pista_atletismo_small.png": 8269,
	"./lazer_ponto-hist_small.png": 8276,
	"./lazer_ponto_hist_small.png": 7355,
	"./lazer_ponto_turistico_small.png": 8409,
	"./lazer_praca_small.png": 4575,
	"./lazer_pracas_small.png": 8516,
	"./lazer_teatro_small.png": 8377,
	"./lazer_turismo_small.png": 3534,
	"./mascara_small.png": 7240,
	"./obra_small.png": 6932,
	"./outro_small.png": 7141,
	"./saude_farmacia_small.png": 2810,
	"./saude_hospital_small.png": 5007,
	"./saude_posto_saude_small.png": 9601,
	"./saude_pronto_socorro_small.png": 919,
	"./seguranca_bombeiro_small.png": 461,
	"./seguranca_civil_small.png": 605,
	"./seguranca_guarda_small.png": 5235,
	"./seguranca_militar_small.png": 7341,
	"./seguranca_municipal_small.png": 943,
	"./transporte_bike_small.png": 921,
	"./transporte_ciclovia_small.png": 4284,
	"./transporte_escolar_small.png": 2557,
	"./transporte_onibus_small.png": 6279,
	"./transporte_taxi_small.png": 6751,
	"./turismo_comercio_small.png": 2725,
	"./turismo_hotel_small.png": 2435,
	"./turismo_restaurante_small.png": 7786,
	"./turismo_restaurantes_small.png": 863
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7697;